import { render, staticRenderFns } from "./AddResultBlParasite.vue?vue&type=template&id=9cf012d6"
import script from "./AddResultBlParasite.vue?vue&type=script&lang=js"
export * from "./AddResultBlParasite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports